import React from 'react';

import './Content.css';

const Content = props => <div className="Content">{props.children}</div>


export default Content;